module.exports = __webpack_public_path__ + "img/ch.8f847d5c.svg";